import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const SearchDetailSynopsis = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  display: -webkit-box;
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
  height: auto;
  margin-top: ${12 * Screen.widthRatio}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  width: 60%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: ${40 * Screen.widthRatio}px;
`;

export default SearchDetailSynopsis;
